// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
export const Ii = "/assets/case-light-DVdfIUL2.webp";
export const jn = "/assets/case-limited-CC_40jBF.webp";
export const Ns = "/assets/case-mystic-9XpuJWEz.webp";
export const Mo = "/assets/case-halloween.webp";
export const Ov = "/assets/fish_blue-D_wZkgWG.webp";
export const kv = "/assets/fish_turquoise-jNbnVXxc.webp";
export const Rv = "/assets/fish_clown-BV97SM8t.webp";
export const Bv = "/assets/fish_green-DlVBg6sE.webp";
export const Uv = "/assets/fish_purple-BVayBwGl.webp";
export const Hv = "/assets/fish_blue_gold-C3m_J8u6.webp";
export const Lv = "/assets/fish_pink-B1ixJ_66.webp";
export const qv = "/assets/fish_gold-Cai1L2mz.webp";
export const Gv = "/assets/fish_ice-Df_Az_MU.webp";
export const Yv = "/assets/fish_red-BndK1-ro.webp";
export const Xv = "/assets/pufferfish-DSW_IQXA.webp";
export const Qv = "/assets/jellyfish-DET8Dz56.webp";
export const Zv = "/assets/squid-roKBkSRb.webp";
export const Vv = "/assets/shark-6xKt_4hv.webp";
export const $v = "/assets/chest-COZm2xdL.webp";
export const Kv = "/assets/bomb-BSvWujXd.webp";
export const Jv = "/assets/deep-water-CB_6G_Qa.webp";
export const Wv = "/assets/surface-TOqGHMiY.webp";
export const Iv = "/assets/midwater-Bi7AnlL5.webp";
export const Fv = "/assets/seafloor-wwGaEuiW.webp";
export const Qy = "/assets/registration-1-IxvTvxFu.webp";
export const Zy = "/assets/registration-2-CnWRL_8v.webp";
export const Vy = "/assets/registration-3-BLaqftuB.webp";
export const $y = "/assets/opened-100-zI9XKLXk.webp";
export const Ky = "/assets/opened-1k-BZdmVWdi.webp";
export const Jy = "/assets/opened-10k-CQtVXxip.webp";
export const Wy = "/assets/opened-25k-Dk5NX1Vt.webp";
export const Iy = "/assets/opened-50k-nSB7aasu.webp";
export const Fy = "/assets/opened-100k-C6c9m0T6.webp";
export const Py = "/assets/opened-500k-DDN9Kalu.webp";
export const e_ = "/assets/opened-1m-vI7eLKWI.webp";
export const i_ = "/assets/instant-lightning-DXjBTBSm.webp";
export const Yo = "/assets/gems-common-985ULHvb.webp";
export const Xo = "/assets/gems-rare-ySPJwxXs.webp";
export const c_ = "/assets/gems-epic-CReWqaSE.webp";
export const u_ = "/assets/gems-legendary-p8oG-r9j.webp";
export const o_ = "/assets/gems-mythic-BSHsky-w.webp";
export const r_ = "/assets/spins-common-BaRhzVXm.webp";
export const Qo = "/assets/spins-rare-Dh-piFSf.webp";
export const Zo = "/assets/spins-epic-CeL8O1up.webp";
export const Vo = "/assets/spins-legendary-BCZQilGF.webp";
export const d_ = "/assets/spins-mythic-cf_1hACI.webp";
export const f_ = "/assets/rak-common-CDKOjyjf.webp";
export const $o = "/assets/rak-rare-DRcr9G0b.webp";
export const Ko = "/assets/rak-epic-C3Y06Dta.webp";
export const h_ = "/assets/rak-legendary-rkH2G4nb.webp";
export const m_ = "/assets/rak-mythic-dEZR5NzC.webp";
export const hm = "/assets/LIMITED-DO5JQdXj.webp";
export const Jo = "/assets/Mystic-C1MFma3d.webp";
export const p_ = "/assets/Theme-QijFeWbO.webp";
export const $m = "/assets/metapass-spins-CYe5GqSn.webp";
export const Km = "/assets/metapass-crystals-CW4lqlbi.webp";
export const n2 = "/assets/metapass-ticket-DeBVgWwq.webp";
export const rj = "/assets/Attack_on_Titan-EFIk2PCB.webp";
export const dj = "/assets/Baki-5EFYkm4v.webp";
export const fj = "/assets/Berserk-BR6vFrZF.webp";
export const hj = "/assets/Black_Clover-U3HT2Uwt.webp";
export const mj = "/assets/Bleach-CzKZojX8.webp";
export const pj = "/assets/Blue_Lock-4BXlj6-i.webp";
export const vj = "/assets/Chainsaw_Man-CAoNm4Kp.webp";
export const bj = "/assets/Classroom_of_the_Elite-CdRoO7vY.webp";
export const gj = "/assets/Code_Geass-Bei3wxmr.webp";
export const yj = "/assets/Death_Note-C3On9jIx.webp";
export const _j = "/assets/Demon_Slayer-BlAS6HJ5.webp";
export const jj = "/assets/DrStone-C6T5WLQB.webp";
export const xj = "/assets/Dragon_Ball-zSHXpbPy.webp";
export const Sj = "/assets/DxD-BCW14lMz.webp";
export const wj = "/assets/Evangelion-IthzWZJh.webp";
export const Nj = "/assets/Fairy_Tail-C665OkkY.webp";
export const Tj = "/assets/Fate-Zm46HKPU.webp";
export const Cj = "/assets/Fire_Force-BBZVvrZd.webp";
export const Mj = "/assets/First_Step-CskIr9Ki.webp";
export const Aj = "/assets/Frieren-Bc4uLKo0.webp";
export const Ej = "/assets/Fullmetal_Alchemist-CTznaziI.webp";
export const Dj = "/assets/Gachiakuta-BsuaclnE.webp";
export const zj = "/assets/Goblin_Slayer-BqU3tzNB.webp";
export const Oj = "/assets/Grand_Blue-BFXXvyUB.webp";
export const kj = "/assets/Gurren_Lagann-Ck3yagD_.webp";
export const Rj = "/assets/Hells_Paradise-BbFxw78u.webp";
export const Bj = "/assets/Hellsing-3A2Jz5fm.webp";
export const Uj = "/assets/Hunter_x_Hunter-BwmdagS-.webp";
export const Hj = "/assets/JnR-BIzzmATk.webp";
export const Lj = "/assets/JoJo-CNv-B78f.webp";
export const qj = "/assets/Jobless_Reincarnation-CorveZlz.webp";
export const Gj = "/assets/Jujutsu_Kaisen-BzBcpXsW.webp";
export const Yj = "/assets/Kaiju-B22JEjOX.webp";
export const Xj = "/assets/Kakegurui-BU9EZHCS.webp";
export const Qj = "/assets/Kenshin-s2FCZz6e.webp";
export const Zj = "/assets/Kuroko_no_Basuke-BbGSl34Z.webp";
export const Vj = "/assets/MDUD-DSLtkZH7.webp";
export const $j = "/assets/MHA-CTY0tBAb.webp";
export const Kj = "/assets/Mob_Psycho_100-YDm0D3QC.webp";
export const Jj = "/assets/Monster-CvqTfuLn.webp";
export const Wj = "/assets/Multiverse-BurK7kWn.webp";
export const Ij = "/assets/Naruto-D0QHhepb.webp";
export const Fj = "/assets/One_Piece-tR4frtG6.webp";
export const Pj = "/assets/OshinoKo-Baij275i.webp";
export const ex = "/assets/ReZero-oGXAWY9w.webp";
export const tx = "/assets/RoR-B1xTv2ft.webp";
export const ax = "/assets/SAO-agaS6OlI.webp";
export const lx = "/assets/Solo_Leveling-CX_WcJ0R.webp";
export const nx = "/assets/Soul_Eater-DkIQdkwf.webp";
export const sx = "/assets/TQQ-CPsHX7IT.webp";
export const ix = "/assets/Tensei_Shitara_Slime_Datta_Ken-BA4-1irb.webp";
export const cx = "/assets/The_Eminence_in_Shadow--VkdtK-t.webp";
export const ux = "/assets/The_Seven_Deadly_Sins-CmXQnYPH.webp";
export const ox = "/assets/Tokyo_Ghoul-DOE-0ENf.webp";
export const rx = "/assets/Tokyo_Revengers-DKMMVf1h.webp";
export const dx = "/assets/Tomodachi_Game-CI5K5hbo.webp";
export const fx = "/assets/Tower_of_God-CmyTyYII.webp";
export const hx = "/assets/Vagabond-B6QOGNjN.webp";
export const mx = "/assets/Vinland_Saga-DB7XQk_9.webp";
export const px = "/assets/onepunchman-CRoeaJ9K.webp";
export const vx = "/assets/%D0%92%D0%BE%D0%BB%D0%B5%D0%B9%D0%B1%D0%BE%D0%BB-CQu4cBkk.webp";
export const Nx = "/assets/metapass-fragments-B9jWe72e.webp";
export const Tx = "/assets/metapass-card-DzQ133F_.webp";
export const Cx = "/assets/metapass-theme-D_BJQiea.webp";
export const Mx = "/assets/metapass-emoji-CZeXNWzx.webp";
export const Ax = "/assets/metapass-upgrade-sATv_dRY.webp";
export const Ox = "/assets/summer-event-bg-3yd6NKyu.webp";
export const kx = "/assets/summer-event-chest-DJSPlgpw.webp";
export const Rx = "/assets/summer-event-foreground-DfZBS_CS.webp";
export const Bx = "/assets/summer-event-palm-uu0eiQ55.webp";
export const Ux = "/assets/summer-event-particles-BXyasRyq.webp";
